'use strict';

class ARAnchoringController {
    constructor() {
        {
            this.menu = undefined;

            this.anchoringObject = undefined;
            this.anchoringObjectSavedMatrix = undefined;

            this.applyARAnchoringTo = false; // "Scene"
            this.ARAnchoringEnabled = false;

            this.isSelectModelPromptMessageOnScreen = false;
            this.selectModelPromptMessage = {};
            this.selectedPoints = [];
            this.anchorLocked = false;
        }

        this.addCustomEvents();
    }


    addCustomEvents() {
        document.addEventListener('startARAnchoring', this.startARAnchoringCallback);
    }

    initMenu(controller, prop, isPresenter) {
        try {
            if (!this.menu) {
                this.menu = new MenuData(ARAnchoringMenu.text, 4, 4);
                // this.menu.itemWidth = 0.056 / 2;
                // this.menu.itemHeight = 0.050 / 2;
                wv.ARAnchoringMenuController = new MenuController(this.menu);
                wv.ARAnchoringMenuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);

                wv.ARAnchoringMenuController.selectionCloseMenuForSingleSelection = true;

                parseChildrenItems(wv.ARAnchoringMenuController, prop.children, menuItemMaps.ARAnchoringItemMenuMap);
            }
            this.menu.isVisible = prop.isVisible;
            this.menu.isPresenter = prop.isPresenter;
            this.menu.isViewer = prop.isViewer;

            controller.appendMenuItem(ARAnchoringMenu.menuItemName, prop.text || ARAnchoringMenu.text, this.menu);
        } catch (error) {
            console.error('Error in AR anchoring menu. Error: ' + error);
        }

    }

    addCancelARAnchoringMenu() {
        let menuView = mController.menuDataView.getThisMenuView(ARAnchoringMenu.menuItemName);
        let menuData = mController.menuData.getThisMenuData(ARAnchoringMenu.menuItemName);

        if (menuData.getThisMenuData("cancelARAnchoring") !== undefined) return;

        let menuItem = new ClickMenuItem("cancelARAnchoring", "Cancel", null, this.cancelARAnchoring);
        if (menuView) {
            mController.menuDataView.insertThisMenuItemToRunningMenuData(ARAnchoringMenu.menuItemName, menuItem);
            menuView.refresh();
        } else {
            menuData.addItem(menuItem);
        }

        if (dummyMenuController) {
            let menuView = dummyMenuController.menuDataView.getThisMenuView(ARAnchoringMenu.menuItemName);
            let menuData = dummyMenuController.menuData.getThisMenuData(ARAnchoringMenu.menuItemName);
            let menuItem = new ClickMenuItem("cancelARAnchoring", "Cancel", null, this.cancelARAnchoring);
            if (menuView) {
                dummyMenuController.menuDataView.insertThisMenuItemToRunningMenuData(ARAnchoringMenu.menuItemName, menuItem);
                menuView.refresh();
            } else {
                menuData.addItem(menuItem);
            }
        }
    }

    removeCancelARAnchoringMenu() {
        let menuView = mController.menuDataView.getThisMenuView(ARAnchoringMenu.menuItemName);
        if (menuView) {
            mController.removeThisMenuItem("cancelARAnchoring", true);
        }
        mController.menuData.removeThisMenuItem("cancelARAnchoring");

        if (dummyMenuController) {
            let menuView = dummyMenuController.menuDataView.getThisMenuView(ARAnchoringMenu.menuItemName);
            if (menuView) {
                dummyMenuController.removeThisMenuItem("cancelARAnchoring", true);
            }
            dummyMenuController.menuData.removeThisMenuItem("cancelARAnchoring");
        }
    }

    updateCheckBoxValue(name, value) {
        let menuView = mController.menuDataView.getThisMenuView(ARAnchoringMenu.menuItemName);
        if (menuView) {
            try {
                menuView.changeCheckBoxItemSelection(name, value);
            } catch (err) {
                console.log("Error: " + err);
            }
        }
    }

    showSelectModelPromptMessage() {
        if (this.isSelectModelPromptMessageOnScreen || !this.ARAnchoringEnabled)
            return;

        this.selectModelPromptMessage = VRMessageController.createMessageObject({text: "Select a model."});
        this.selectModelPromptMessage.updateScaling();
        this.selectModelPromptMessage.message.object.position.set(0, -1.0, -4.0);

        iq3Camera.camera.add(this.selectModelPromptMessage.message.object);
        this.isSelectModelPromptMessageOnScreen = true;
    }

    hideSelectModelPromptMessage() {
        if (!this.isSelectModelPromptMessageOnScreen)
            return;

        iq3Camera.camera.remove(this.selectModelPromptMessage.message.object);
        this.isSelectModelPromptMessageOnScreen = false;
    }

    showAnchoringPromptMessage() {
        VRMessageController.addMessage({text: "Virtual object alignment is enabled.\nSelect a suitable horizontal physical surface"});
    }

    modelSelectionCallbackHandler(value) {
        manageFeatureAndCallbackHandler(
            wv.mouseClickCallbackHandler,
            {callback: this.modelSelectionHandler},
            value, ARAnchoringMenu.text);

        manageFeatureAndCallbackHandler(
            wv.controllerTriggerDownCallbackhandler,
            {callback: this.modelSelectionHandler},
            value, ARAnchoringMenu.text);

    }

    modelSelectionHandler(eventData) {
        if (instance.ARAnchoringEnabled !== true || !instance.applyARAnchoringTo || wv.rootObject.children.length <= 0)
            return false;

        instance.anchoringObject = getModelObject(eventData.pickingData.modelName);
        if (instance.anchoringObject === undefined) {
            return false;
        }

        instance.modelSelectionCallbackHandler(false);
        if (instance.isSelectModelPromptMessageOnScreen) {
            instance.hideSelectModelPromptMessage();
        }

        // highlight selected model
        modelManager.highlightModelObject(instance.anchoringObject.model_name, true);

        // start anchoring
        document.dispatchEvent(new CustomEvent('startARAnchoring'));
    }

    enableARAnchoringCallback(value) {
        if(!value) {
            instance.endARAnchoring();
            return;
        }

        if (!(iq3XRSession.mode === SessionMode.AR && iq3XRSession.isSessionRunning())) {

            VRMessageController.addMessage({
                text: "You must be in AR mode to use this capability",
                priority: VrMessagePriorityEnum.HIGHPRIORITYINFO
            });

            instance.updateCheckBoxValue('enableARAnchoring', false);
            return ;
        }

        VRMessageController.addMessage({text: "Hit testing is enabled"});
        instance.ARAnchoringEnabled = true;

        // add cancel button
        instance.addCancelARAnchoringMenu();

        // Anchor is changed to “Locked”
        instance.lockAnchor();

        if (instance.applyARAnchoringTo) {
            instance.showSelectModelPromptMessage();
            instance.modelSelectionCallbackHandler(true);
        }
        else {
            // start anchoring
            document.dispatchEvent(new CustomEvent('startARAnchoring'));
        }
    }

    startARAnchoringCallback(event) {
        if (!instance.ARAnchoringEnabled) return;

        if (instance.isSelectModelPromptMessageOnScreen) {
            instance.hideSelectModelPromptMessage();
        }

        if (instance.anchoringObject === undefined || !instance.applyARAnchoringTo) instance.anchoringObject = wv.floorGroup;

        if (!wv.isHitTestingEnabled) {
            // XRHitTest.setPhysicalPickin(true)g
        }

        //        save position
        instance.anchoringObject.updateMatrix();
        instance.anchoringObject.updateMatrixWorld(true);
        instance.anchoringObjectSavedMatrix = new THREE.Matrix4();
        instance.anchoringObjectSavedMatrix.copy(instance.anchoringObject.matrix);

        instance.showAnchoringPromptMessage();
    }

    undoHitTestingPointSelection(){
        if (ModelAlignController.pickingData.length > 0) {
            ModelAlignController.pickingData.pop();
        }
    }

    applyNow() {

    }


    endARAnchoring() {
        // turn off selection process if running
        instance.modelSelectionCallbackHandler(false);
        if (instance.isSelectModelPromptMessageOnScreen) {
            instance.hideSelectModelPromptMessage();
        }

        // Model (if selected) is deselected
        if (instance.anchoringObject !== undefined) {
            modelManager.highlightModelObject(instance.anchoringObject.model_name, false);
            instance.anchoringObject = undefined;
        }

        // turn off anchoring process
        instance.ARAnchoringEnabled = false;
        if (wv.isHitTestingEnabled) {
            XRHitTest.setPhysicalPicking(true);
        }

        // Anchor is changed to “unLocked”
        instance.unlockAnchor();

        // Cancel button disappears
        instance.removeCancelARAnchoringMenu();

        // Finish is changed to Start
        instance.updateCheckBoxValue('enableARAnchoring', false);
    }

    cancelARAnchoring() {
        // Model/Scene is returned to original position (as determined from when the Start button was clicked)
        instance.resetObjectPosition();
        instance.endARAnchoring();
    }

    lockOrUnlockAnchorCallback (lockAnchor) {
        if (lockAnchor) instance.lockAnchor();
        else instance.unlockAnchor();
    }

    lockAnchor() {
        this.anchorLocked = true;
        this.updateCheckBoxValue('lockOrUnlockAnchor', this.anchorLocked);

        wv.effectController.lockUserMovement = true;
        sendLockUserMovementFromSession(true);
    }

    unlockAnchor() {
        this.anchorLocked = false;
        this.updateCheckBoxValue('lockOrUnlockAnchor', this.anchorLocked);

        wv.effectController.lockUserMovement = false;
        sendLockUserMovementFromSession(false);
    }

    resetObjectPosition() {
        if (this.anchoringObject === undefined) return;
        updateObjectMatrix(this.anchoringObject, this.anchoringObjectSavedMatrix);
    }

    applyARAnchoringToCallback(currentValue) {
        instance.applyARAnchoringTo = currentValue;
        if (!instance.ARAnchoringEnabled) return;

        if (currentValue) {
            // model
            instance.anchoringObject = undefined;

            instance.showSelectModelPromptMessage();
            instance.modelSelectionCallbackHandler(true);
        }
        else {
            if (instance.isSelectModelPromptMessageOnScreen) {
                instance.hideSelectModelPromptMessage();
                instance.modelSelectionCallbackHandler(false);
            }

            if (instance.anchoringObject !== undefined) {
                modelManager.highlightModelObject(instance.anchoringObject.model_name, false);
            }

            instance.anchoringObject = wv.floorGroup;
            instance.showAnchoringPromptMessage();
        }
    }

}

const instance = new ARAnchoringController();

export default instance;